/**
 * @generated SignedSource<<35ccc65b518c43aa26a837fbb85d9d7e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_nativeIssueTable_IssueCountRenderer$data = {
  readonly isCappingIssueSearchResult: boolean | null | undefined;
  readonly issueNavigatorPageInfo: {
    readonly firstIssuePosition: number | null | undefined;
    readonly lastIssuePosition: number | null | undefined;
  } | null | undefined;
  readonly totalIssueSearchResultCount: number | null | undefined;
  readonly " $fragmentType": "main_nativeIssueTable_IssueCountRenderer";
};
export type main_nativeIssueTable_IssueCountRenderer$key = {
  readonly " $data"?: main_nativeIssueTable_IssueCountRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_nativeIssueTable_IssueCountRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_nativeIssueTable_IssueCountRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "totalIssueSearchResultCount"
    },
    {
      "kind": "ScalarField",
      "name": "isCappingIssueSearchResult"
    },
    {
      "concreteType": "JiraIssueNavigatorPageInfo",
      "kind": "LinkedField",
      "name": "issueNavigatorPageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "firstIssuePosition"
        },
        {
          "kind": "ScalarField",
          "name": "lastIssuePosition"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "178c5569a8b7d626dbb883809268743a";

export default node;
